/** @format */

import HomeMap from '../Components/HomeMap';
import MainHeader from '../Components/MainHeader';
import HomeSearch from '../Components/HomeSearch';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import './Home.css';

const Home = () => {
  const [ismodal, setIsModal] = useState(false);
  const [searchModal, setSearchModal] = useState(false);
  let selectRideItem = '';
  const parentFunction = (x) => {
    setIsModal(x);
  };

  const isPc = useMediaQuery({
    query: '(min-width: 768px)',
  });

  const homeSearchParentFunction = (x) => {
    selectRideItem = x;
    setIsModal(true);
    setSearchModal(false);
  };

  return (
    <div className="home">
      <MainHeader parentFunction={parentFunction} />
      <div className="homeMap">
        <HomeMap Num={selectRideItem} />
      </div>
      {searchModal && !isPc ? (
        <HomeSearch homeSearchParentFunction={homeSearchParentFunction} />
      ) : null}
      {searchModal && !isPc ? (
        <div
          className="mobileSearchCloseButton"
          onClick={() => {
            setSearchModal(false);
          }}></div>
      ) : null}
      {isPc ? (
        <HomeSearch homeSearchParentFunction={homeSearchParentFunction} />
      ) : (
        <div
          className="searchModalButton"
          onClick={() => {
            setSearchModal(true);
          }}>
          {' '}
          <div>Search</div>{' '}
        </div>
      )}
    </div>
  );
};

export default Home;
